import { BasicEnvironment } from '@irian-ro/util-environment';
import { IpensiiAuthConfig } from './auth.model';

export enum HttpMethod {
  GET = 'GET',
}

export interface RequestMatcher {
  url: string;
  method?: HttpMethod;
}

export interface IpEnvironment extends BasicEnvironment {
  production?: boolean;
  config: IpensiiAuthConfig;
  adminUrl: string;
  employerUrl: string,
  backendUrl: string;
  apiUrl: string;
  usersUrl: string;
  rolesUrl: string;
  exceptionsUrl: string,
  notificationsUrl: string,
  reportingBasePathUrl: string,
  jobSystemBasePathUrl: string,
  presentationUrl: string;
  publicRequests: Array<RequestMatcher>;
}
